<template>
    <div>
        <!--图表标题-->
        <Card :padding="0">
            <p slot="title" class="card-title" v-if="showTitle">
                <Icon type="map"></Icon>
                {{chartsTitle}}
            </p>
            <!--点击查看更多-->
            <a href="#" slot="extra" @click.prevent="changeLimit" v-if="isShowMore">
                <Icon type="ios-loop-strong"></Icon>
                查看更多
            </a>
            <!--图表-->
            <div :style="{height: height}">
                <div style="width:100%;height:100%;" :id="chartsId" v-show="!isShow"></div>
                <div class="chart-error" v-show="isShow">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
    export default {
        name: "pie-charts",
        props:{
            chartsTitle:String,//图表标题
            chartsId:String,//图表Id
            pieChartsName:String,//饼图名称
            isShowMore:Boolean,//是否展示查看更多
            isClickCharts:Boolean,//是否可以点击饼图
            showTitle:{
                type:Boolean,
                default:true
            },
            height:{
                type:String,
                default:'360px'
            },
            pieRadiusArr:{
                type:Array,
                default:()=>[0,'55%']
            },
            colorArr:{
                type:Array,
                default:()=>["DeepSkyBlue", "LightPink", "Moccasin", "LightBlue", "#DDA0DD"]
            }
        },
        data () {
            return {
                isShow:false,//默认不展示缺醒图
                dataSource:null
            }
        },
        methods:{
            /**
             * 查看更多数据
             */
            changeLimit () {
                this.$emit('look-more-data',this.chartsId);
            },
            /**
             * 渲染图表
             */
            initDataSource (data,nameArr,dataArr) {
                let _this = this;
                _this.dataSource = _this.$echarts.init(
                    document.getElementById(_this.chartsId)
                );
                _this.dataSource.off('click');
                _this.isShow =data.length <= 0;
                const option = {
                    color: _this.colorArr,
                    title: {
                        show:_this.showTitle,
                        text: "",
                        x: "center"
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: "vertical",
                        left: "15px",
                        top:'50%',
                        fontColor:"#999",
                        data: nameArr,
                        textStyle: {
                            color:'#999', //颜色
                            fontSize: "14px" //大小
                        },
                    },
                    series: [
                        {
                            name: _this.pieChartsName,
                            type: "pie",
                            radius: _this.pieRadiusArr,
                            center: ["50%", "55%"],
                            data: dataArr,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                    borderColor: "#ffffff"
                                },
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)"
                                }
                            }
                        }
                    ]
                };
                _this.dataSource.setOption(option);
                if(_this.isClickCharts){
                    _this.dataSource.on('click', function (params) {
                        _this.$emit('click-more-data','pie',params,_this.chartsId);
                    });
                }
                window.addEventListener("resize", function () {
                    _this.dataSource.resize();
                });
            }
        },
        // beforeDestroy () {
        //     this.dataSource.clear()
        // },
        mounted(){

        }
    }
</script>

<style lang="scss" scoped>
    @import "../../style/common";
</style>
